
















import {
  computed,
  defineComponent,
  inject,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  Ref,
} from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { PostFileData } from "@/types";
import { EVENTS } from "@/const";
import CheckAuthorities from "@/components/CheckAuthorities";
import OptionItem from "../OptionItem";
import OptionPreviewThumbnail from "../OptionPreviewThumbnail";

export default defineComponent({
  name: "OptionPreview",
  components: { CheckAuthorities, OptionPreviewThumbnail, OptionItem },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props) {
    const { authUser } = useAuthUser();
    const priceOneTime = ref(0);
    const priceRecurring = ref(0);
    const fileList = inject<Ref<PostFileData[]>>("fileList", ref<PostFileData[]>([]));
    const requiredAuthorities = computed(() => {
      const isAuthor = props.postData.userId === authUser.value?.id;
      return isAuthor
        ? ["updateMyContentPrice", "updateMyContentSubscriptionLevel"]
        : ["updateAnyContentPrice", "updateAnyContentSubscriptionLevel"];
    });
    const showOption = computed(
      () =>
        !(priceOneTime.value === 0 && priceRecurring.value === 0) && props.postData.type !== ContentFeedTypeEnum.EVENT
    );
    const previews = computed<PostFileData[]>(() => fileList.value.filter(i => i.public));
    const onPriceChange = ({
      recurringLevel,
      oneTimePackage,
    }: {
      recurringLevel: SubscriptionLevel | null;
      oneTimePackage: PaymentPackage | null;
    }) => {
      priceOneTime.value = oneTimePackage?.amount ?? 0;
      priceRecurring.value = recurringLevel?.pricePackage?.amount ?? 0;
    };

    const onClick = () => {
      emitter.emit(EVENTS.CONTENT_FEED_PREVIEW_SHOW);
    };

    onMounted(() => {
      emitter.on<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChange);
    });

    onBeforeUnmount(() => {
      emitter.off<any>(EVENTS.CONTENT_FEED_PRICE_CHANGED, onPriceChange);
    });

    return {
      requiredAuthorities,
      showOption,
      previews,
      onClick,
    };
  },
});
